import { filterInvalidChanges } from '../ScheduleComponentPage.helper';
import { ChangeItem } from '../ScheduleComponentPage.interface';

export const getMinPosition = (
  changes: ChangeItem[],
  earliestDate?: string | null,
): number => {
  const validChanges = filterInvalidChanges(changes);

  const changedPositions = validChanges
    .map((change) => change.data?.position)
    .filter((pos) => pos !== undefined) as number[];

  if (changedPositions.length === 0) return 1;

  // If earliestDate is provided, find the lowest position with that date
  if (earliestDate) {
    let lowestPosition = Infinity;
    for (const change of validChanges) {
      const position = change.data?.position;
      const startDate = change.data?.start_date;

      if (position && startDate === earliestDate) {
        lowestPosition = Math.min(lowestPosition, position);
      }
    }

    if (lowestPosition !== Infinity) {
      return lowestPosition;
    }
  }

  // Fallback: return the lowest position if no startDate is available
  return Math.min(...changedPositions);
};
